<div class="navigation-container no-padding toolbar mat-elevation-z4" style="padding:12px;">
  <div class="navigation-left">
    <a class="logo" routerLink="/" routerLinkActive="active">
      <img src="assets/img/mediserv-header.gif" width="auto" height="80px">
    </a>

    @if (navigationItem) {
      <span [routerLink]="navigationItem.route" class="nav-back">
        <app-icon [icon]="'back'"></app-icon> {{ 'core.navigation.' + navigationItem.name | translate }}
      </span>
    }
  </div>
  <ul class="navigation-right">
    <li>
      @if (this.oroservice.IsLoggedIn) {
        <button mat-flat-button (click)="selectOrder()" color="primary"
          style="height: 38px; top:-4px;position: relative;">
          <mat-icon>assignment</mat-icon>&nbsp;
          {{'Neuauftrag.Einreichen' | translate}}
        </button>
      }
    </li>
    @if (this.oroservice.IsLoggedIn) {
      <li>
        <a>
          <span class="choosegp">
            @if (this.oroservice.kundeninfo.Gps) {
              <select class="form-control title" name="gpauswahl"
                id="gpauswahl" (change)="reloadroute($event.target.value)">
                @for (gp of this.oroservice.kundeninfo.Gps; track gp) {
                  <option [selected]="this.isGpSelected(gp.Id)"
                  [value]="gp.Id">{{gp.Caption}}</option>
                }
              </select>
            }
          </span>
        </a>
      </li>
    }
    <li><a [ngClass]="{'activecountry': this.cookieservice.get('lang') =='de','inactivecountry': this.cookieservice.get('lang') !='de'}"
      (click)="SetDE()"><span>DE</span></a></li>
      <li><a [ngClass]="{'activecountry': this.cookieservice.get('lang') =='fr','inactivecountry': this.cookieservice.get('lang') !='fr'}"
        (click)="SetFR()"><span>FR</span></a></li>
        <!-- <li><a [ngClass]="{'activecountry': this.cookieservice.get('lang') =='it' ,'inactivecountry': this.cookieservice.get('lang') !='it'}"
        (click)="SetIT()"><span>IT</span></a></li> -->

        @if (this.oroservice.IsLoggedIn) {
          <li>
            <a (click)="this.Logout()">
              <mat-icon style="color:#be0000; font-weight: 900; top: 5px; position: relative; cursor: pointer;"
              matTooltip="{{ 'Abmelden' | translate }}">login</mat-icon>
            </a>
          </li>
        }
      </ul>
    </div>

    <div>
      @if (!this.oroservice.IsLoggedIn) {
        <img class="banner-image" src="assets/img/portal-banner.jfif" alt="">
      }

      @if (this.oroservice.IsLoggedIn) {
        <div class="orange-zone" style="margin: 0px; height:24px;">&nbsp;</div>
      }

      @if (this.oroservice.IsLoggedIn && _router.url != '/auftrag') {
        <nav [mat-stretch-tabs]="false" mat-tab-nav-bar>
          <a mat-tab-link
            routerLink="/Startseite"
            routerLinkActive #rla="routerLinkActive"
            [active]="rla.isActive">
            <mat-icon>home</mat-icon>&nbsp;{{'Home' | translate}}
          </a>
          <a mat-tab-link
            routerLink="/Auftraege"
            routerLinkActive #rla2="routerLinkActive"
            [active]="rla2.isActive">
            <mat-icon>assignment</mat-icon>&nbsp;{{'Aufträge.title' | translate}}
          </a>
          <a mat-tab-link
            routerLink="/Dokumente"
            style="width:150px"
            routerLinkActive #rla3="routerLinkActive"
            [active]="rla3.isActive">
            <mat-icon>description</mat-icon>&nbsp;
            <span [matBadge]="documentCount"
            matBadgeOverlap="false">{{'Dokumente.title' | translate}}</span>
          </a>
          <a mat-tab-link
            routerLink="/Dossier"
            routerLinkActive #rla4="routerLinkActive"
            [active]="rla4.isActive">
            <mat-icon>folder_open</mat-icon>&nbsp;{{'Dossier.title' | translate}}
          </a>
          @if (this.oroservice.kundeninfo.IsMaster) {
            <a mat-tab-link
              routerLink="/Stammdaten"
              routerLinkActive #rla5="routerLinkActive"
              [active]="rla5.isActive">
              <mat-icon>person</mat-icon>&nbsp;{{'Profil' | translate}}
            </a>
          }
          <a mat-tab-link
            routerLink="/Kundenkonto"
            routerLinkActive #rla7="routerLinkActive"
            [active]="rla7.isActive">
            <mat-icon>account_balance</mat-icon>&nbsp;{{'Kundenkonto.title' | translate}}
          </a>
          @if (this.oroservice.kundeninfo.IsMaster) {
            <a mat-tab-link
              routerLink="/Kundeneinstellungen"
              routerLinkActive #rla8="routerLinkActive"
              [active]="rla8.isActive">
              <mat-icon>settings</mat-icon>&nbsp;{{'Einstellungen.title' | translate}}
            </a>
          }
          @if (this.oroservice.kundeninfo.IsMaster) {
            <a mat-tab-link
              routerLink="/Reporting"
              routerLinkActive #rla9="routerLinkActive"
              [active]="rla9.isActive">
              <mat-icon>view_list</mat-icon>&nbsp;{{'Reporting.Title' | translate}}
            </a>
          }
          @if (this.oroservice.kundeninfo.IsMaster) {
            <a mat-tab-link
              routerLink="/Verwaltung"
              routerLinkActive #rla10="routerLinkActive"
              [active]="rla10.isActive">
              <mat-icon>supervisor_account</mat-icon>&nbsp;{{'Verwaltung.Title' | translate}}
            </a>
          }
          <!-- <a mat-tab-link
          routerLink="/Blocklist"
          routerLinkActive #rla11="routerLinkActive"
          [active]="rla11.isActive">
          <mat-icon>account_box</mat-icon>&nbsp;{{'Blocklist.title' | translate}}
        </a> -->
        <a mat-tab-link
          routerLink="/Userdaten"
          routerLinkActive #rla12="routerLinkActive"
          [active]="rla12.isActive">
          <mat-icon>person</mat-icon>&nbsp;{{'UserData' | translate}}
        </a>
      </nav>
    }

    <main>
      <router-outlet></router-outlet>
    </main>
  </div>
